/**
 * @package Bears Demo content
 * Demo content panel script
 */


export default function() {

}
